module.exports = __webpack_public_path__ + "static/media/img_15.f6fdb085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_15.jpg
// module id = 533
// module chunks = 0